import ConfirmDialogController from './confirm-dialog.controller';
import { ConfirmDialogProps } from './confirm-dialog.model';

const ConfirmDialog = (props: ConfirmDialogProps) => {
  return <ConfirmDialogController {...props} />;
};

export default ConfirmDialog;
